import React, { useEffect, useState } from "react";
import { useT } from "@/lib/i18n";
import { RefreshCw, X } from "lucide-react";

/**
 * Listens for SW update broadcasts (postMessage type 'SW_UPDATED') and shows
 * a non-blocking toast banner inviting the user to reload to get the new version.
 */
export default function PwaUpdatePrompt() {
  const { lang } = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const onMsg = (e) => {
      if (e.data?.type === "SW_UPDATED") setShow(true);
    };
    navigator.serviceWorker?.addEventListener?.("message", onMsg);
    // Also detect waiting SW on initial load
    navigator.serviceWorker?.getRegistration?.()?.then?.((reg) => {
      if (reg?.waiting) setShow(true);
    });
    return () => navigator.serviceWorker?.removeEventListener?.("message", onMsg);
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="pwa-update-prompt"
      className="fixed top-4 left-1/2 -translate-x-1/2 z-50 rounded-full bg-[#1F3A5F] text-white px-4 py-2 flex items-center gap-3 shadow-xl"
    >
      <RefreshCw className="w-4 h-4" />
      <span className="text-sm font-bold">
        {lang === "fr" ? "Nouvelle version disponible" : "New version available"}
      </span>
      <button
        data-testid="pwa-update-reload"
        onClick={() => window.location.reload()}
        className="px-3 py-1 rounded-full bg-[#E5276A] hover:bg-[#C01661] text-xs font-bold"
      >
        {lang === "fr" ? "Recharger" : "Reload"}
      </button>
      <button onClick={() => setShow(false)} className="text-white/60 hover:text-white">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
